import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { OrganizationDetails } from "@/services/DTOs/OrganizationDetails";
import { SolarApiService } from "./SolarApiService";

class Service {
  public getUserAdminRolesOrganizations(): Observable<OrganizationDetails[]> {
    const url = "/api/tiamat/organizations/admin-member/me";
    return SolarApiService.get(url).pipe(map((response) => response.data));
  }

  public getOrganizationsByUser(): Observable<OrganizationDetails[]> {
    const url = "/api/tiamat/organizations/members/me";
    return SolarApiService.get(url).pipe(map((response) => response.data));
  }
}

export const OrganizationService = new Service();
